// Health Connect values are read on the device and never included in an API write.
export function healthLinkPayload(workout) {
  if (workout?.provider === "health_connect") return { provider: "health_connect", workoutId: workout.workoutId }
  return workout
}
